import { useStyles } from '@archipro-design/aria';
import HeroTitle from './HeroTitle';
import HeroContent from './HeroContent';

import { DEFAULT_TITLE } from '@modules/articles/config/constants';
import type { DirectoryHeaderProps } from './DirectoryHeader';

import * as S from './DirectoryHeader.style';

export const DirectoryHeaderDesktop: React.FC<DirectoryHeaderProps> = ({
    content,
    title,
}) => {
    const { css } = useStyles();

    return (
        <div className={css(S.PageHeader)}>
            <div className={css(S.PageHeaderInner)}>
                <div className={css(S.LeftPane)}>
                    <HeroContent content={content} />
                </div>
                <div className={css(S.RightPane)}>
                    <HeroTitle title={title ?? DEFAULT_TITLE} />
                </div>
            </div>
        </div>
    );
};
